
document.addEventListener('DOMContentLoaded', function() {
  var links = document.querySelectorAll('.site-nav__link');
  links.forEach(function(el) {
    var nodes = el.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === 3) {
        var text = node.textContent.trim();
        if (text.length === 0) continue;
        var codePoint = text.codePointAt(0);
        if (codePoint > 127) {
          var emoji = String.fromCodePoint(codePoint);
          var remaining = text.substring(emoji.length);
          var span = document.createElement('span');
          span.className = 'nav-emoji';
          span.textContent = emoji;
          node.textContent = ' ' + remaining;
          el.insertBefore(span, node);
          break;
        }
      }
    }
  });
});
